// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

/**
 * A deprecated table is one that is the type of a field that is no longer used.
 * Flatbuffers stores all complex objects (i.e. tables) as offsets, so in a
 * deprecated field, we can make the type this to make it an "empty" offset,
 * allowing us to remove the prior type from our code.
 */
export class Deprecated {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):Deprecated {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsDeprecated(bb:flatbuffers.ByteBuffer, obj?:Deprecated):Deprecated {
  return (obj || new Deprecated()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsDeprecated(bb:flatbuffers.ByteBuffer, obj?:Deprecated):Deprecated {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Deprecated()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static startDeprecated(builder:flatbuffers.Builder) {
  builder.startObject(0);
}

static endDeprecated(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createDeprecated(builder:flatbuffers.Builder):flatbuffers.Offset {
  Deprecated.startDeprecated(builder);
  return Deprecated.endDeprecated(builder);
}
}
